import { defineComponent as _defineComponent } from 'vue';
import { PanelLeft } from "lucide-vue-next";
import { cn } from '../../primitives/utils';
import { Button } from '../../primitives/button';
import { useSidebar } from "./utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarTrigger',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { toggleSidebar } = useSidebar();
        const __returned__ = { props, toggleSidebar, get PanelLeft() { return PanelLeft; }, get cn() { return cn; }, get Button() { return Button; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
